<template>
    <div>
        <!-- 角色管理 -->
        <el-card>
            <div slot="header">
                <!--<router-link  :to="{ path:'/roleAdd', query:{ callback:request} }">-->
                    <!--&lt;!&ndash;v-w-role=" 'ITSM-0091'"&ndash;&gt;-->
                    <!--<el-button type="primary">创建</el-button>-->
                <!--</router-link>-->
            </div>
            <el-table :data="tableData">
                <el-table-column width="80" align="center" label="序号" >
                    <template slot-scope="scope">{{ scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="角色名称" prop="roleName"></el-table-column>
                <el-table-column label="创建时间" prop="createTime" ></el-table-column>
                <!--<el-table-column label="操作" width="130" align="left">-->
                    <!--<template slot-scope="scope">-->
                        <!--<div style="white-space: nowrap;">-->
                            <!--<router-link :to="{path:'/roleAdd',query:{ params:scope.row,type:'edit',callback:request}}">-->
                                <!--<el-button type="text">修改</el-button>-->
                            <!--</router-link>-->
                            <!--<el-button  class="table-del-btn" type="text" @click="deleteRole(scope.row)">删除</el-button>-->
                        <!--</div>-->
                    <!--</template>-->
                <!--</el-table-column>-->
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.page"
                           :page-sizes="[10,20]"
                           :page-size="form.limit"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>

        </el-card>

    </div>
</template>

<script>
    import services from "./system.service"
    export default {
        data() {
            return {
                form:{
                    page:1,
                    limit:10,
                },
                total:null,
                tableData:[]
            }
        },
        created() {
            this.request();
        },
        methods: {
            request(){
                services.getRoleListPage(this.form).then(res => {
                    this.tableData = res.list;
                    this.total = res.totalCount;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                }).catch(() => {
                });
            },
            deleteRole(row){
                this.openMessage('您确定要删除角色吗？', '确定', () => {
                    services.deleteRole(row).then(() => {
                        this.$message({type: 'success', message: '删除成功!'});
                        this.request();
                    }).catch((err) => {
                        this.$message({type: 'error', message: err.message});
                    })
                });
            },
            handleSizeChange(val){
                this.form.limit = val;
                this.request()
            },
            handleCurrentChange(val){
                this.form.page = val;
                this.request();
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
